import axios from 'axios'

axios.defaults.baseURL = process.env.VUE_APP_API_URL

export default {
  install (Vue) {
    Vue.prototype.$proxy = {}

    Vue.prototype.$proxy.get = function (path) {
      return new Promise((resolve, reject) => {
        let lang = localStorage.getItem('vendorPortalLang')
        if (!lang) {
          lang = 'en'
        }
        if (path.indexOf('?') > 0) {
          path = `${path}&lang=${lang}&ts=${+new Date()}`
        } else {
          path = `${path}?lang=${lang}&ts=${+new Date()}`
        }
        const acceptLanguage = lang === 'en' ? 'en-US' : 'es-MX'
        return axios.get(path, { headers: { 'Accept-Language': acceptLanguage } })
          .then((d) => {
            resolve(d)
          })
          .catch((e) => {
            reject(e)
          })
      })
    }

    Vue.prototype.$proxy.getDownload = function (path, timeout = 300000) {
      return new Promise((resolve, reject) => {
        let lang = localStorage.getItem('vendorPortalLang')
        if (!lang) {
          lang = 'en'
        }
        if (path.indexOf('?') > 0) {
          path = `${path}&lang=${lang}&ts=${+new Date()}`
        } else {
          path = `${path}?lang=${lang}&ts=${+new Date()}`
        }
        return axios({
          method: 'get',
          url: path,
          responseType: 'blob',
          timeout
        })
          .then((r) => {
            resolve(r)
          })
          .catch((e) => {
            reject(e)
          })
      })
    }

    Vue.prototype.$proxy.post = function (path, payload = {}, responseType) {
      return new Promise((resolve, reject) => {
        let lang = localStorage.getItem('vendorPortalLang')
        if (!lang) {
          lang = 'en'
        }
        if (path.indexOf('?') > 0) {
          path = `${path}&lang=${lang}`
        } else {
          path = `${path}?lang=${lang}`
        }
        const acceptLanguage = lang === 'en' ? 'en-US' : 'es-MX'
        return axios.post(path, payload, { headers: { 'Content-Type': 'application/json', 'Accept-Language': acceptLanguage }, responseType: responseType })
          .then((d) => {
            resolve(d)
          })
          .catch((e) => {
            reject(e)
          })
      })
    }

    Vue.prototype.$proxy.postMultipart = function (path, payload = {}) {
      return new Promise((resolve, reject) => {
        let lang = localStorage.getItem('vendorPortalLang')
        if (!lang) {
          lang = 'en'
        }
        if (path.indexOf('?') > 0) {
          path = `${path}&lang=${lang}`
        } else {
          path = `${path}?lang=${lang}`
        }
        return axios.post(path, payload, { headers: { 'Content-Type': 'multipart/form-data' } })
          .then((d) => {
            resolve(d)
          })
          .catch((e) => {
            reject(e)
          })
      })
    }

    Vue.prototype.$proxy.put = function (path, payload = {}) {
      return new Promise((resolve, reject) => {
        let lang = localStorage.getItem('vendorPortalLang')
        if (!lang) {
          lang = 'en'
        }
        if (path.indexOf('?') > 0) {
          path = `${path}&lang=${lang}`
        } else {
          path = `${path}?lang=${lang}`
        }
        return axios.put(path, payload)
          .then((d) => {
            resolve(d)
          })
          .catch((e) => {
            reject(e)
          })
      })
    }

    Vue.prototype.$proxy.delete = function (path) {
      return new Promise((resolve, reject) => {
        let lang = localStorage.getItem('vendorPortalLang')
        if (!lang) {
          lang = 'en'
        }
        if (path.indexOf('?') > 0) {
          path = `${path}&lang=${lang}`
        } else {
          path = `${path}?lang=${lang}`
        }
        return axios.delete(path)
          .then((d) => {
            resolve(d)
          })
          .catch((e) => {
            reject(e)
          })
      })
    }
  }
}
